import BaseApi from '../base'

const path = '/admin/local-deployment'

export default class LocalDeploymentApi extends BaseApi {
  constructor() {
    super(path)
  }
  static GetInstance = () => new LocalDeploymentApi()

  decryptToken = (params) => this.post(`${path}/decrypt`, params)
  updateToken = (params) => this.put(`${path}/token`, params)
}
